import { useTranslation } from "react-i18next"

import { SEO } from "."

export const DefaultSEO: React.FC = () => {
  const { t } = useTranslation("home")

  return <SEO pageTitle={t("metadata.title")} withTitleSuffix={false} />
}
